<template>
  <div>
    <page-title-bar :customTitle="customTitle"></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0" height="auto">
            <v-layout row justify-end align-center style="padding: 32px">
              <v-flex xs12 md4>
                <div style="max-width: 290px">
                  <v-menu :close-on-content-click="false" v-model="menu_month_picker" :nudge-right="40" lazy
                    transition="scale-transition" offset-y full-width min-width="290px" max-width="290px"
                    :disabled="loader">
                    <v-text-field slot="activator" v-model="chosen_month" label="Chọn tháng" :disabled="loader"
                      prepend-icon="event" readonly hide-details></v-text-field>
                    <v-date-picker min="2025-03" locale="vi-VI" type="month" v-model="chosen_month"
                      @input="menu_month_picker = false"></v-date-picker>
                  </v-menu>
                </div>
              </v-flex>
            </v-layout>
          </v-toolbar>

          <div class="mt-3">
            <v-card>
              <v-data-table disable-initial-sort :headers="headers" :items="items" item-key="id"
                :rows-per-page-items="rowPerPage">
                <template #items="props">
                  <tr>
                    <td class="text-center text-no-wrap">
                      {{ props.item.account_classification }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.vas }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.account_code }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.text }}
                    </td>
                    <td :class="`text-${props.item.ui_position || 'right'} text-no-wrap`">
                      {{ props.item.opening_balance | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.debit | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.credit | formatCurrency }}
                    </td>
                    <td :class="`text-${props.item.ui_position || 'right'} text-no-wrap`">
                      {{ props.item.end_balance | formatCurrency }}
                    </td>
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <print-portal layout="portrait" :open="print_table" @close="print_table = false">
      <print-so-tien-mat :items="items"></print-so-tien-mat>
    </print-portal>
  </div>
</template>

<script>
import moment from "moment";
import api from "Api";
import { buildParamQuery } from "Helpers";

export default {
  name: "tb",
  data() {
    return {
      loader: false,
      headers: [
        {
          text: "Phân loại",
          align: "center",
          sortable: true,
          value: "account_classification",
        },
        {
          text: "VAS",
          align: "center",
          sortable: true,
          value: "vas",
        },
        {
          text: "Số tài khoản",
          align: "center",
          sortable: true,
          value: "account_code",
        },
        {
          text: "Tài khoản",
          align: "center",
          sortable: true,
          value: "text",
        },
        {
          text: "Số dư đầu kỳ",
          align: "center",
          sortable: true,
          value: "opening_balance",
          width: "320px",
        },
        {
          text: "Phát sinh nợ",
          align: "center",
          sortable: true,
          value: "debit",
        },
        {
          text: "Phát sinh có",
          align: "center",
          sortable: true,
          value: "credit",
        },
        {
          text: "Số dư cuối kỳ",
          align: "center",
          sortable: true,
          value: "end_balance",
          width: "320px"
        },
      ],
      export_csv: {
        loader: false,
        trigger: false,
        title: "",
        rows: [],
      },
      items: [],
      print_table: false,
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
      menu_month_picker: false,
      chosen_month: new Date().toISOString().substring(0, 7),
    };
  },
  watch: {
    chosen_month: function () {
      this.getData();
    },
  },

  mounted() {
    this.getData();
  },
  created() { },
  computed: {
    customTitle() {
      return "Bảng cân đối tài khoản (TB)";
    },
  },
  methods: {
    getData: async function () {
      this.loader = true;

      const params = {
        chosenMonth: this.chosen_month,
        dateStart: moment(this.chosen_month).format("YYYY-MM-01"),
        dateEnd: moment(this.chosen_month)
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
      const query = buildParamQuery(params);
      const result = await api.getTB(query);

      const { tbData } = result.data;

      this.items = [];

      this.items = tbData.slice(0);

      this.loader = false;
    },
  },
};
</script>
